import { Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { isPathActive } from '../../Utilities/HelperMethods';
import { navButtonStyles, navButtonActiveStyles } from './StyledComponents';

export const NavButton = ({ to, label, location, toggleDrawer }) => {
  const isActive = isPathActive(location.pathname, to);

  return (
    <Button
      component={NavLink}
      to={to}
      sx={{
        ...navButtonStyles,
        ...(isActive && {
          ...navButtonActiveStyles,
        }),
      }}
      onClick={toggleDrawer}
    >
      {label}
    </Button>
  );
};
